<template>
  <div class="roleManagement">
    <commonHeader :tabs-list="tabsList" :tabs-default="activeName" @handleTabsClick="handleTabsClick" :breadcrumb-show="false" />
    <roleView v-if="activeName ==='roleView'" />
    <staffView v-if="activeName ==='staffView'" />
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import roleView from './component/roleManagement/roleView';
import staffView from './component/roleManagement/staffView';
export default {
  data () {
    return {
      activeName: 'roleView',
      tabsList: [
        {
          label: '按角色查看',
          name: 'roleView'
        },
        {
          label: '按员工查看',
          name: 'staffView'
        }
      ]
    };
  },
  components: {
    commonHeader,
    roleView,
    staffView
  },
  methods: {
    handleTabsClick (val) {
      this.activeName = val.name;
    }
  }
};
</script>

<style scoped>

</style>
